
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-library/category/[category]",
      function () {
        return require("private-next-pages/video-library/category/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-library/category/[category]"])
      });
    }
  